import type { ReactNode } from 'react';

/**
 * The centred brand frame the signed-out screens share: balloon, wordmark, and
 * whatever the screen itself is below it.
 *
 * Three pages reach someone who is not signed in — the sign-in screen, a staff
 * invitation, and an email action link — and they are the only places the brand
 * has to introduce itself, since everything past them sits inside a layout.
 */
export function AuthScreen({ children }: { children: ReactNode }) {
  return (
    <div className='tw:flex tw:min-h-screen tw:flex-col tw:items-center tw:justify-center tw:bg-ed-black tw:px-6 tw:text-center'>
      <img src='/eightydays_balloon.png' alt='Eighty Days' className='tw:mb-6 tw:h-16 tw:w-auto tw:object-contain' />
      <h1 className='tw:font-serif tw:text-3xl tw:tracking-wider tw:text-white tw:uppercase'>Eighty Days</h1>
      <p className='tw:mt-2 tw:mb-10 tw:text-xs tw:tracking-[0.35em] tw:text-ed-gold/70 tw:uppercase'>
        Exclusive Experiences
      </p>
      {children}
    </div>
  );
}
